'use client'

import { ComponentProps } from 'react'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'

import OfferRequestMessageWithConversationContext from './OfferRequestMessageWithConversationContext'
import InquiryOfferRequestMessage from './InquiryOfferRequestMessage'

type Props = ComponentProps<typeof OfferRequestMessageWithConversationContext>

const OfferRequestMessage = (props: Props) => {
  const isWebMessagingSvcFSEnabled = useFeatureSwitch('web_messaging_svc')

  const OfferRequestMessageComponent = isWebMessagingSvcFSEnabled
    ? InquiryOfferRequestMessage
    : OfferRequestMessageWithConversationContext

  return <OfferRequestMessageComponent {...props} />
}

export default OfferRequestMessage
